import { useContext } from 'solid-js';
import { AppContext } from '../../app-context-provider/app-context-provider';
import DynamicModuleGenerator from '../../dynamic-module-generator';
import theme, { ColorName } from '../../style/theme';
import { ExpandableContainer } from '../expandable-container/expandable-container';
import { StyledExpandableContentInner, StyledExpandableWrapper } from './expandable-content.style';

export type ExpandableContentProps = {
    bgColor: ColorName;
    heading?: string;
    content?: any;
};

export const ExpandableContent = (props: ExpandableContentProps) => {
    const { viewport } = useContext(AppContext);
    
    const isMobile = () => viewport.width <= theme.breakpoints.MOBILE;

    const Component = (props: ExpandableContentProps) => (
        <ExpandableContainer
            initialOpen={false}
            chevronColor={theme.palette.red}
            chevronSize={isMobile() ? 1.5 : 2.14}
            roundCorners={true}
            withDividerLine={true}
            disableOutsideClickToClose={true}
            headingProps={{
                noBlockSpacing: true,
                tag: 'h2',
                variant: 'small',
                children: props.heading,
            }}
            customHeadingRowCss={
                `background-color: ${props.bgColor === 'lightBeige' || props.bgColor === 'white'
                    ? theme.palette[props.bgColor]
                    : theme.palette.lightBeige
                };
                padding: ${theme.spacing.s} ${theme.spacing.xl};
                border-top-left-radius: ${theme.borderRadius.medium};
                border-top-right-radius: ${theme.borderRadius.medium};
                padding-inline: ${theme.spacing.xl};

                ${theme.containerQueries.mobileMax} {
                    padding-inline: ${theme.spacing.xs};
                }
            `}
        >
            <StyledExpandableContentInner bgColor={props.bgColor}>
                <DynamicModuleGenerator
                    content={props.content}
                    skipSectionConversion={true}
                />
            </StyledExpandableContentInner>
        </ExpandableContainer>
    );

    return (
        <StyledExpandableWrapper>
            <Component 
                heading={props.heading}
                content={props.content}
                bgColor={props.bgColor}
            />
        </StyledExpandableWrapper>
    );
};

ExpandableContent.parseProps = (atts: any) => {
    return {
        heading: atts.heading,
        content: atts.content,
        bgColor: atts.bgColor || 'lightBeige',
    };
};

